const cities = [
  { name: "Jacksonville", zips: "32073, 32202, 32204, 32205, 32207, 32210, 32211, 32216, 32217, 32218, 32223, 32224, 32225, 32226, 32233, 32244, 32246, 32250, 32256, 32257, 32258, 32259" },
  { name: "Orange Park", zips: "32073" },
  { name: "Fleming Island", zips: "32003" },
  { name: "St. Augustine", zips: "32080, 32084, 32086" },
  { name: "Amelia Island / Fernandina Beach", zips: "32034" },
];

const landmarks = [
  { name: "Jacksonville International Airport (JAX)", distance: "~15 miles", icon: "ri-plane-line", desc: "Major regional airport — direct international flights, 15-min drive from downtown on I-95" },
  { name: "I-95", distance: "Adjacent", icon: "ri-road-map-line", desc: "Primary north-south corridor through Jacksonville's urban core" },
  { name: "I-10", distance: "Adjacent", icon: "ri-road-map-line", desc: "East-west interstate connecting Jacksonville to Tallahassee and points west" },
  { name: "I-295", distance: "Beltway", icon: "ri-road-map-line", desc: "Jacksonville's outer beltway connecting all major neighborhoods and suburbs" },
  { name: "NAS Jacksonville", distance: "~10 miles", icon: "ri-ship-line", desc: "Major naval air station — one of the largest Navy bases in the Southeast" },
  { name: "Naval Station Mayport", distance: "~15 miles", icon: "ri-anchor-line", desc: "East Coast naval station — home to aircraft carriers and surface ships" },
  { name: "JAXPORT Cruise Terminal", distance: "~8 miles", icon: "ri-ship-line", desc: "Cruise terminal serving Bahamas & Caribbean itineraries north of downtown" },
  { name: "TIAA Bank Field", distance: "Downtown", icon: "ri-trophy-line", desc: "Home of the Jacksonville Jaguars — 67,000-seat NFL stadium on the St. Johns River" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from your home, barracks, dorm, or office in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle every detail from there.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function JacksonvilleLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white pt-6 md:pt-8 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Jacksonville &amp; Northeast Florida
          </h2>
        </div>

        {/* 300–500 word intro block */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Jacksonville, Florida is a city defined by movement. With three major military installations — Naval Air Station Jacksonville, Naval Station Mayport, and Blount Island Command — thousands of service members rotate through this region on compressed timelines. PCS orders often arrive with 30 days or less to report, and many overseas assignments require current passports for dependents. That creates a demand pattern unlike almost any other Florida city: urgent, non-negotiable, and frequently discovered at the last minute.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Beyond the military, Jacksonville is Northeast Florida's business and logistics capital. The Port of Jacksonville (JAXPORT) is one of the busiest vehicle export ports on the East Coast, and the city hosts regional headquarters for major financial services, healthcare, and logistics companies. Business travelers here do not always have the luxury of six-month advance planning — international meetings, site inspections, and contract negotiations happen on short notice. When a downtown executive realizes their passport expired during the pandemic-era travel lull, they need a solution that works on a business timeline, not a government one.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              The cruise and leisure travel market adds another dimension. JAXPORT's cruise terminal serves Bahamas and Caribbean itineraries that book heavily from the Jacksonville, St. Augustine, and Amelia Island areas. Families often reserve cruise cabins during promotional windows, then discover a child's passport expired or a spouse never obtained one. College students at the University of North Florida or Jacksonville University plan study-abroad semesters with application deadlines that standard processing cannot meet. And retirees along the St. Johns River and Intracoastal Waterway maintain active travel schedules to Europe and Latin America that depend on predictable passport turnaround.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              Fast Passport Center was built for exactly these scenarios. We provide the expedited, professional passport service that Jacksonville's diverse traveler base demands: dedicated agents who understand military timelines, document review that catches errors before they cost you a cruise or deployment slot, and processing as fast as 24 hours for true emergencies. No traveling to Atlanta. No waiting for an appointment that may never open. Just reliable, predictable service from a registered U.S. Department of State courier.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — FPC Info + How It Works */}
          <div>
            {/* FPC Info Card */}
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex flex-col gap-6">
                {/* Info side */}
                <div className="w-full">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Jacksonville, FL</p>
                  <p className="text-white/60 text-xs mt-0.5">50 N Laura St, Jacksonville, FL 32202</p>
                  <a
                    href="https://maps.google.com/maps?daddr=50+N+Laura+St,+Jacksonville,+FL+32202"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="inline-flex items-center gap-1 text-[#F6C344] hover:text-white text-xs font-semibold mt-1 transition-colors"
                  >
                    <i className="ri-navigation-line"></i> Get Driving Directions on Google Maps
                  </a>
                </div>
              </div>

              {/* Phone Number */}
              <div className="flex items-start gap-2.5 mb-3 ml-[52px]">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-[#F6C344] text-xs"></i>
                </div>
                <div>
                  <a href="tel:8772530084" className="text-white/80 text-sm hover:text-[#F6C344] transition-colors">(877) 253-0084</a>
                  <p className="text-white/40 text-xs">Nationwide toll-free — 24/7 voicemail</p>
                </div>
              </div>

              {/* Office Hours */}
              <div className="flex items-start gap-2.5 mb-4 ml-[52px]">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-[#F6C344] text-xs"></i>
                </div>
                <div>
                  <div className="text-white/80 text-sm space-y-0.5">
                    <p className="whitespace-nowrap">Monday – Friday: 9:00 AM – 6:00 PM EST</p>
                    <p className="whitespace-nowrap">Saturday: 10:00 AM – 2:00 PM EST</p>
                    <p className="whitespace-nowrap">Sunday: Closed</p>
                  </div>
                  <p className="text-[#F6C344] text-xs mt-1.5 font-medium">Appointment suggested</p>
                  <p className="text-white/40 text-xs mt-0.5">Appointment suggested to ensure your documents are reviewed before you arrive.</p>
                  <p className="text-white/40 text-xs mt-2">Last updated: July 18, 2026</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Local office — serving Jacksonville, Orange Park &amp; Northeast Florida
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout Duval &amp; St. Johns counties</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location, or <strong className="text-white">schedule a drop-off</strong> at our Jacksonville office. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

                {/* Map side */}
                <div className="w-full">
                  <div className="rounded-lg overflow-hidden border border-white/10" style={{ height: '260px' }}>
                    <iframe
                      src="https://maps.google.com/maps?q=50+N+Laura+St,+Jacksonville,+FL+32202&t=&z=15&ie=UTF8&iwloc=&output=embed"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Fast Passport Center Jacksonville Office Location"
                      aria-label="Google Map showing Fast Passport Center Jacksonville office at 50 N Laura St"
                    />
                  </div>
                  <p className="text-white/40 text-xs mt-2 text-center">
                    50 N Laura St, Jacksonville, FL 32202
                  </p>
                </div>
              </div>
            </div>

            {/* How FPC Helps */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Cities We Serve + Trust strip */}
          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono hidden sm:inline">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Northeast Florida — start online, ship overnight, and we handle the rest. As a registered courier, we have guaranteed submission availability at regional passport agencies.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "Ponte Vedra Beach", href: "/ponte-vedra-beach" },
                    { name: "Orlando", href: "/orlando" },
                    { name: "Tampa", href: "/tampa" },
                    { name: "Tallahassee", href: "/tallahassee" },
                    { name: "St. Augustine", href: "/florida" },
                    { name: "Daytona Beach", href: "/florida" },
                  ].map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Trust credentials strip */}
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Jacksonville Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* Nearby Landmarks & Airports */}
            <div className="mt-6">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#F6C344]/15">
                  <i className="ri-landscape-line text-[#1A365D] text-xs"></i>
                </div>
                <h3 className="font-semibold text-[#1A365D] text-sm uppercase tracking-wide">Nearby Landmarks &amp; Airports</h3>
              </div>
              <div className="flex flex-wrap gap-1.5">
                {landmarks.map((item) => (
                  <span
                    key={item.name}
                    className="inline-flex items-center gap-1.5 bg-[#F7F8FA] border border-gray-200/80 rounded-full px-3 py-1.5 hover:border-[#F6C344] transition-colors cursor-default whitespace-nowrap"
                    title={item.desc}
                  >
                    <i className={`${item.icon} text-[#1A365D] text-[10px]`}></i>
                    <span className="text-[#1A365D] font-medium text-[11px]">{item.name}</span>
                    <span className="text-[#F6C344] font-semibold text-[10px]">{item.distance}</span>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}